const { Teachers } = require('./Teachers');
const { CreateTeacher } = require('./CreateTeacher');
const { UpdateTeacher } = require('./UpdateTeacher');

export { Teachers, CreateTeacher, UpdateTeacher };
